module.exports = __webpack_public_path__ + "img/norway-respiratory-diseases-male.4792d416.png";